import { gql } from '@apollo/client';

export const CREATE_VOTE = gql`
  mutation CreateVote(
    $resourceType: String!
    $resourceId: String!
    $voteType: String!
  ) {
    createVote(
      input: {
        resourceType: $resourceType
        resourceId: $resourceId
        voteType: $voteType
      }
    ) {
      success
      error
    }
  }
`;
